import { Box, Flex } from 'ui/Layout';

import DataEditor from '../../components/DataEditor';
import NodeImbalances from '../../components/NodeImbalances';
import { InteractiveSankeyChart } from '../../components/SankeyChart';
import { useSankeyFormContext } from '../../contexts/sankeyFormContext';
import { useCanvasColumnProps } from './utils';

const EditorDesktopLayout: React.FC = () => {
  const canvasColumnProps = useCanvasColumnProps();
  const { form } = useSankeyFormContext();

  return (
    <Flex alignItems="start" gap={4} justifyContent="center">
      <Flex flex={3} {...canvasColumnProps}>
        <InteractiveSankeyChart />
        {form.getValues('show_imbalances') && <NodeImbalances />}
      </Flex>
      {form.getValues('show_data_editor') && (
        <Box flexGrow={1} maxW={800}>
          <DataEditor />
        </Box>
      )}
    </Flex>
  );
};

export default EditorDesktopLayout;
